export { MyAccountPopoverController as MyAccountPopover } from './my-account-popover-controller';
